import { app, appVersion, env, isApp } from '../getNativeInfo';
import { numberVersion } from '../utils';
import { apiConfig } from './api-config';
/**
 * 检测是否可以使用指定的 API？
 */
export function canIUse(apiName) {
  var apiConfigItem = apiConfig[apiName];
  if (!isApp) {
    return Boolean(apiConfigItem === null || apiConfigItem === void 0 ? void 0 : apiConfigItem.isNativeAPI);
  }
  var apiVersion = apiConfigItem === null || apiConfigItem === void 0 ? void 0 : apiConfigItem[env];
  if (!apiVersion) {
    return false;
  }
  // temp: 特殊处理
  if (app === 'bcz-lite' || app === 'vld') {
    return true;
  }
  var numberAppVersion = Number(appVersion);
  var apiVersionRange = typeof apiVersion === 'string' ? {
    from: apiVersion
  } : apiVersion;
  var apiVersionFrom = numberVersion(apiVersionRange.from);
  var apiVersionTo = apiVersionRange.to ? numberVersion(apiVersionRange.to) : Infinity;
  return numberAppVersion >= apiVersionFrom && numberAppVersion <= apiVersionTo;
}